{
  "accountDetails": "Account details",
  "last12months": "Last 12 months (with transactions)",
  "last10years": "Last 10 years",
  "stats": "Stats",
  "goToReports": "Go to reports",
  "synchronisingChanges": "Synchronising changes...",
  "noConnectedAccount": "Link a deposit account",
  "initialSaldo": "Your bank did not provide any details for the initial transaction. If necessary, split it into smaller transactions and adjust dates.",
  "help": "Click to see help for this view.",
  "errorFieldRequired": "Field is required",
  "errorOneRowRequired": "At least one entry is required",
  "errorMustBePositive": "Must be positive",
  "errorMustBeNumber": "Must be a number",
  "multipleSelected": "You can select multiple.",
  "effectiveDate": "Effective date",
  "value": "Value",
  "estimateType": "Select estimate type",
  "quote": "Payout",
  "quoteInCurrency": "Payout in {{currency}}",
  "create": "Create",
  "quotesEmptyGeneric": "Nothing to display",
  "quotesEmptyStocksManualOnly": "Only values you entered manually are shown here. Add custom stock values in the Edit mode to see it here.",
  "quotesEmptyStocks": {
    "heading": "Stock Quotes",
    "subheading": "No synced market values available",
    "intro": "This view currently shows only manually entered quote values for your holdings.",
    "featureTitle": "Manual values only"
  },
  "buttons": {
    "duplicatesFound": "We found potential duplicates in your transactions. Please review them and uncheck the ones you don't need.",
    "editYourFile": "You can edit your file now. Click >Save< to save your changes or >Cancel< to go back.",
    "fileTransformed": "Your file has been modified to replicate the changes you made to it last time.",
    "fileTransformedUndo": "Undo changes",
    "firstUpload": "This is your first upload for this account. We will store your selection for future use.",
    "loading": "Processing...",
    "loadingTakesLong": "This process may take longer than 30 seconds.",
    "columnMatcherHeader": "Which column from your file goes where?",
    "columnMatcherInfo": "Drag the column headers to their correct places in the top row. Some headers may have already been placed for you. Hovering over the table icons will show a preview of your file. You don't have to use all the columns from your file.",
    "columnName": "Column name",
    "customColumnDescription": "Customised column",
    "dragToScroll": "Drag above to scroll",
    "occursInRows": "Occurs in rows",
    "headersInRow": {
      "label": "Headers in row:",
      "tooltip": "Which row in your file contains the column headers?"
    },
    "decimalChar": {
      "label": "Decimal character:",
      "tooltip": "Does your file use a comma or a dot as the decimal character?"
    },
    "readOnly": {
      "tooltip": "You can add future transactions to Projects and they will appear here.",
      "label": "This view is read-only in Project Mode."
    },
    "whatYouOwn": {
      "label": "What you own",
      "tooltip": "Display a list of purchases and sales of your investments."
    },
    "whatIsItWorth": {
      "label": "What is it worth",
      "tooltip": "Display changing value of your investments over time."
    },
    "payments": {
      "label": "Payments",
      "tooltip": "Display contributions and payouts."
    },
    "presentValue": {
      "label": "Value",
      "tooltip": "Display expected monthly payments as reported by your product provider."
    },
    "sync": {
      "tooltip": "Import transactions automatically."
    },
    "tableFilters": {
      "label": "Filter",
      "labelWithCount": "Filter ({{count}})",
      "tooltip": "Filter the visible rows by phrase, amount and date."
    },
    "import": {
      "label": "Import",
      "tooltip": "Import transactions from a file."
    },
    "table": {
      "label": "Table",
      "tooltip": "Display a list of transactions."
    },
    "grid": {
      "label": "Edit",
      "tooltip": "Edit the transactions in a spreadsheet."
    },
    "wizard": {
      "label": "Edit",
      "tooltip": "Edit the holdings or values through a wizard."
    },
    "holdings": {
      "label": "Holdings",
      "tooltip": "Displays your holdings."
    },
    "cashflow": {
      "label": "Payouts & costs",
      "tooltip": "Displays all payouts (dividends, interests, etc.) and all costs associated with this account."
    },
    "quotes": {
      "label": "Value",
      "tooltip": "Displays value changes of your holdings."
    },
    "settings": {
      "label": "Settings",
      "tooltip": "Display account settings."
    },
    "close": {
      "label": "Close",
      "tooltip": "Abandon changes and go back to Dashboard."
    },
    "save": {
      "label": "Save",
      "tooltip": "Permanently save this change."
    },
    "saveAndClose": {
      "label": "Save and close",
      "tooltip": "Save this change and go back to Import screen."
    },
    "cancel": {
      "label": "Cancel",
      "tooltip": "Cancel and go back to Table view."
    },
    "undo": {
      "label": "Undo",
      "tooltip": "Undo last change."
    },
    "redo": {
      "label": "Redo",
      "tooltip": "Repeat last change."
    },
    "uploadFiles": {
      "label": "Upload files",
      "tooltip": "Upload local files to Monestry."
    },
    "cancelFileUpload": {
      "label": "Cancel file upload",
      "tooltip": "Closes this dialog without uploading anything."
    },
    "resetColumns": {
      "label": "Reset columns",
      "tooltip": "Resets all mappings."
    },
    "editLoadedFile": {
      "label": "Edit imported file",
      "tooltip": "Edit the file you have uploaded."
    },
    "confirmAndContinue": {
      "label": "Confirm and continue",
      "tooltip": "Proceeds with importing the file according to mappings specified below."
    },
    "skipThisFile": {
      "label": "Skip this file",
      "tooltip": "Skips this file (without uploading it) and moves on to the next one."
    },
    "addAnotherOperation": {
      "label": "Add another operation",
      "tooltip": "You can add more columns to your custom column."
    },
    "newColumn": {
      "label": "Add new column",
      "tooltip": "Adds and edits new columns, based on two or more existing columns."
    },
    "columnProperties": {
      "label": "Properties",
      "tooltip": ""
    },
    "columnActions": {
      "label": "Actions",
      "tooltip": ""
    },
    "deleteThisColumn": {
      "label": "Delete this column",
      "tooltip": "Deletes this column and all its contents."
    },
    "historicalValueCalc": {
      "label": "Don't know purchase price?",
      "tooltip": "This button will estimate the purchase price based on the purchase date and attributes (weight, purity etc.). You can adjust it later."
    },
    "previous": {
      "label": "< Previous",
      "tooltip": "Open details of the previous record."
    },
    "next": {
      "label": "Next >",
      "tooltip": "Open details of the next record."
    }
  },
  "attributes": {
    "category": {
      "tooltip": "Category of this account"
    },
    "bankName": {
      "tooltip": "Bank providing this account"
    },
    "brokerName": {
      "tooltip": "Broker providing this account"
    },
    "iban": {
      "tooltip": "This account's IBAN (account number)"
    },
    "accountNo": {
      "tooltip": "This account's number",
      "stub": "Account number?"
    },
    "bic": {
      "tooltip": "BIC (routing code) of the bank where this account is at"
    },
    "connectedCashAccount": {
      "tooltip": "Bank account where payments to and from this account are made.",
      "error": "Error: no connected cash account found"
    },
    "streetAddress": {
      "tooltip": "Street address of your property"
    },
    "floorArea": {
      "tooltip": "Floor area of your property"
    },
    "numberOfRooms": {
      "tooltip": "Number of rooms in your property"
    },
    "lotArea": {
      "tooltip": "Area of the lot your property is on"
    },
    "constructionYear": {
      "tooltip": "Construction year"
    },
    "garage": {
      "tooltip": "Is there a garage or a dedicated parking space?"
    },
    "currency": {
      "tooltip": "Currency used for tracking this property's value"
    },
    "multiple": "connected accounts"
  },
  "columns": {
    "standardTooltip": "Click to sort by this column or reverse the sorting order.",
    "emptyString": "",
    "readOnly": "(read-only)",
    "category": "category",
    "date": "Date",
    "Date (Day)": "Date",
    "Date (Month)": "Date",
    "Date (Year)": "Date",
    "Income from capital": "Income from capital",
    "accountName": "Account",
    "displayName": "Name",
    "total": "Total",
    "otherParty": "Other party",
    "otherPartyAccount": "Other party account",
    "symbol": "Symbol",
    "description": "Description",
    "amount": {
      "label": "Amount",
      "tooltip": "Transaction amount in your account currency. If you provide currency and the original currency amount, this field will be calculated automatically."
    },
    "label": {
      "label": "Label",
      "tooltip": "What kind of transaction is this? These labels make it possible to calculate your net worth and other statistics."
    },
    "quantity": {
      "label": "Quantity",
      "tooltip": "Number of assets bought (positive number) or sold (negative number)."
    },
    "principal": {
      "label": "Principal",
      "tooltip": "Principal part of loan installment (i.e. repaid capital)."
    },
    "interest": {
      "label": "Interest",
      "tooltip": "Interest part of loan installment (i.e. interest paid for this period)."
    },
    "iban": {
      "label": "IBAN",
      "tooltip": "Other party account's IBAN (account number)"
    },
    "transactionAmount": {
      "label": "Amount",
      "tooltip": "Amount of shares bought or sold"
    },
    "transactionPrice": {
      "label": "Unit price",
      "tooltip": "Price per share, in the currency of the transaction"
    },
    "transactionCurrency": {
      "label": "Currency",
      "tooltip": "Currency of the transaction"
    },
    "type": "Type",
    "fxCurrency": {
      "label": "Original currency",
      "tooltip": "Original currency of the transaction (optional)"
    },
    "fxAmount": {
      "label": "Original amount",
      "tooltip": "Transaction amount in original currency (optional)"
    },
    "fxAmountInterest": {
      "label": "Original interest amount",
      "tooltip": "Transaction interest amount in original currency (optional)"
    },
    "fxRate": {
      "label": "Exchange rate",
      "tooltip": "Exchange rate between original currency and your account currency (calculated automatically)"
    },
    "value": "Value",
    "rebasedOriginalValue": "Value\n(transaction\ncurrency)",
    "rebasedValue": "Value\n(base\ncurrency)",
    "rebasedAmount": {
      "label": "Amount\nafter\nsplits",
      "tooltip": "If there were any splits between the transaction date and today, this is the amount of shares which these shares are now."
    },
    "assetId": {
      "label": "Asset",
      "tooltip": "Which asset is this quote for?"
    },
    "assetName": {
      "label": "Asset name",
      "tooltip": "How would you like to refer to this asset?"
    },
    "assetMetal": {
      "label": "Metal",
      "tooltip": "What precious metal is this? Pick from a list."
    },
    "assetPurity": {
      "label": "Purity",
      "tooltip": "Different forms of precious metal assets have different purities, e.g. .999 for gold. Enter the purity of your asset in parts per thousand (999 or 965)."
    },
    "assetAdditionalValue": {
      "label": "Extra value",
      "tooltip": "Some coins or other assets have additional value due to their rarity or artistic significance. Enter the extra value of your asset in percent (this will be added to the pure metal value). If the metal alone is worth 100 and additional value is 20%, then we will calculate the value of this coin to be 120. When metal price increases, we will keep adding the 20% for this asset."
    },
    "assetWeight": {
      "label": "Weight",
      "tooltip": "How much does this asset weigh? Please enter weight in grams."
    },
    "transactionValue": {
      "label": "Transaction sum",
      "tooltip": "Optional. Quantity purchased / sold * price per unit. If you enter both those values, we will calculate it automatically."
    },
    "transactionCurrencyValue": {
      "label": "Original sum",
      "tooltip": "Optional. Quantity purchased / sold * price per unit in original transation currency. If you enter both those values, we will calculate it automatically."
    },
    "rebasedOriginalPrice": {
      "label": "Price\nafter\nsplits",
      "tooltip": "When stocks split, their price is divided as well. This is the hypothetical price per share of the transaction shares after considering all the splits that happened since."
    },
    "pricePerSquareMetre": "Price per m2",
    "originalPricePerSquareMetre": "Price\n(original\ncurrency)\nper m2",
    "transactionType": {
      "label": "Transaction type",
      "tooltip": "Purchase or sale of the property."
    },
    "realEstateTransactionPrice": {
      "label": "Price\n(base\ncurrency)",
      "tooltip": "Shows the actual sale or purchase price, in your base currency. You can provide this price or the original price, the other will be calculated automatically."
    },
    "realEstateOriginalPrice": {
      "label": "Price\n(original\ncurrency)",
      "tooltip": "Shows the actual sale or purchase price, in the original currency. You can provide this price or the transaction price, the other will be calculated automatically."
    },
    "source": {
      "label": "Source",
      "tooltip": "Shows if the valuation comes from the valuation provider or entered manually. Click to sort by this column or reverse the sorting order."
    },
    "price": {
      "label": "Value\n(base\ncurrency)",
      "tooltip": "Shows what price would this property be sold for at a given date, in your base currency. Click to sort by this column or reverse the sorting order.",
      "tooltipGrid": "If you provide original currency and price, this column will be calculated automatically."
    },
    "priceShort": {
      "label": "Price"
    },
    "currency": "Original\ncurrency",
    "originalPrice": {
      "label": "Value\n(original\ncurrency)",
      "tooltip": "Shows what price would this property be sold for at a given date, in the original currency. Click to sort by this column or reverse the sorting order.",
      "tooltipGrid": "If you provide original currency and your base currency price, this column will be calculated automatically."
    },
    "size": {
      "label": "Quantity",
      "tooltip": "Amount of still unsold securities from the transaction which took place at the specified date. Click to sort by this column or reverse the sorting order."
    },
    "split": {
      "label": "Split",
      "tooltip": "Proportion of old stocks to new stocks."
    },
    "openPositionSize": {
      "label": "Remaining quantity",
      "tooltip": "Amount of still unsold securities from the transaction which took place at the specified date. Click to sort by this column or reverse the sorting order."
    },
    "purchaseValue": {
      "label": "Purchase",
      "tooltip": "Value when purchasing the securities in your base currency. Click to sort by this column or reverse the sorting order."
    },
    "purchaseValueFull": {
      "label": "Purchase value",
      "tooltip": "Value when purchasing the securities in your base currency. Click to sort by this column or reverse the sorting order."
    },
    "baselineValue": {
      "label": "Baseline /",
      "tooltip": "Value of the securities in your base currency at the baseline date that you selected. Click to sort by this column or reverse the sorting order."
    },
    "currentValue": {
      "label": "Current value",
      "tooltip": "Current value of the securities in your base currency. Click to sort by this column or reverse the sorting order."
    },
    "purchasePrice": {
      "label": "Purchase /",
      "tooltip": "Price when purchasing the securities in your base currency. Click to sort by this column or reverse the sorting order."
    },
    "valueTransactionCurrency": {
      "label": "Value\n(transaction\ncurrency)",
      "tooltip": "Optional. Value of the asset in the original transaction currency. Click to sort by this column or reverse the sorting order."
    },
    "valueAccountCurrency": {
      "label": "Value",
      "tooltip": "Optional. Value of the asset in the account currency. Click to sort by this column or reverse the sorting order."
    },
    "valueBaseCurrency": {
      "label": "Value\n(base\ncurrency)",
      "tooltip": "Optional. Value of the asset in your overall base currency. Click to sort by this column or reverse the sorting order."
    },
    "baselinePrice": {
      "label": "Baseline /",
      "tooltip": "Price of the securities in your base currency at the baseline date that you selected. Click to sort by this column or reverse the sorting order."
    },
    "currentPrice": {
      "label": "Current price",
      "tooltip": "Current price of the securities in your base currency. Click to sort by this column or reverse the sorting order."
    },
    "purchaseCurrentValuePrice": {
      "label": "Value / price",
      "tooltip": "Price and value when purchasing the securities as well as currently, in your base currency. Click to sort by this column or reverse the sorting order."
    },
    "purchaseValuePrice": {
      "label": "Purchase value / price",
      "tooltip": "Price and value when purchasing the securities in your base currency. Click to sort by this column or reverse the sorting order."
    },
    "baselineValuePrice": {
      "label": "Baseline value / price",
      "tooltip": "Price and value of the securities in your base currency at the baseline date that you selected. Click to sort by this column or reverse the sorting order."
    },
    "currentValuePrice": {
      "label": "Current value / price",
      "tooltip": "Current price and value of the securities in your base currency. Click to sort by this column or reverse the sorting order."
    },
    "dividendsSincePurchase": {
      "label": "Dividends / fees since purchase",
      "tooltip": "Sum of all dividends and fees incurred for those securities since purchase + account costs in proportion to open position value. Click to sort by this column or reverse the sorting order."
    },
    "dividends": {
      "label": "Payouts / fees",
      "tooltip": "Sum of all dividends and fees incurred for those securities since purchase. Click to sort by this column or reverse the sorting order."
    },
    "roi": {
      "label": "ROI total / ROI per year",
      "tooltip": "Return on investment for your securities - total (since purchase until now) and annualised (average growth per year since purchase until now). Includes dividends and fees. Click to sort by this column or reverse the sorting order."
    },
    "roiShort": {
      "label": "ROI total / annual",
      "tooltip": "Return on investment for your securities - total (since purchase until now) and annualised (average growth per year since purchase until now). Includes dividends and fees. Click to sort by this column or reverse the sorting order."
    },
    "roiOnly": {
      "label": "ROI",
      "tooltip": "Return on investment for your securities - total (since purchase until now). Includes dividends and fees. Click to sort by this column or reverse the sorting order."
    },
    "payoutsSincePurchase": {
      "label": "Payouts since purchase",
      "tooltip": "Payouts for assets since their purchase. Click to sort by this column or reverse the sorting order."
    },
    "feesSincePurchase": {
      "label": "Fees since purchase",
      "tooltip": "Fees related to assets since their purchase. Click to sort by this column or reverse the sorting order."
    },
    "costsSincePurchase": {
      "label": "Costs since purchase",
      "tooltip": "Costs related to assets since their purchase. Click to sort by this column or reverse the sorting order."
    },
    "roiAnnual": {
      "label": "Annual ROI",
      "tooltip": "Return on investment for your securities - annualised (average growth per year since purchase until now). Includes dividends and fees. Click to sort by this column or reverse the sorting order."
    },
    "keepFlag": {
      "label": "Keep?",
      "tooltip": "Entferne Markierung bei den Zeilen, die nicht importiert werden sollen."
    },
    "payoutOnlyContributionsToDate": {
      "label": "Pension from contributions\nto-date",
      "tooltip": "Pension that you would receive if you stopped paying contributions today."
    },
    "payoutOnlyContributionsToDateIndexed": {
      "label": "Pension from contributions\nto-date (indexed)",
      "tooltip": "Pension that you would receive if you stopped paying contributions today, but with interest applied to them until pension payout phase."
    },
    "payoutAllPlannedContributions": {
      "label": "Pension from all\nfuture contributions",
      "tooltip": "Pension that you would receive if you keep paying contributions until pension payout phase."
    },
    "payoutAllPlannedContributionsIndexed": {
      "label": "Pension from all\nfuture contributions (indexed)",
      "tooltip": "Pension that you would receive if you keep paying contributions until pension payout phase, but with interest applied to them until pension payout phase."
    },
    "payoutLumpSumVerrentet": {
      "label": "Lump sum converted to perpetual pension",
      "tooltip": "Capital you have accumulated will be converted into a perpetual annuity. We will automatically calculate the recurring payment."
    },
    "note": {
      "label": "Note",
      "tooltip": "Valuation details"
    },
    "proceeds": {
      "label": "Proceeds",
      "tooltip": "Income from this asset"
    }
  },
  "deposits": {
    "labels": {
      "noLabel": {
        "long": "No label",
        "short": "No label"
      },
      "investment-fees": {
        "long": "Transaction fees",
        "short": "Fees"
      },
      "investment-costs": {
        "long": "Account costs",
        "short": "Costs"
      },
      "investment-interest": {
        "long": "Account interest",
        "short": "Interest"
      },
      "investment-dividend": {
        "long": "Dividend",
        "short": "Dividend"
      },
      "investment-transfer": {
        "long": "Transfer",
        "short": "Transfer"
      },
      "investment-rent": {
        "long": "Rent income",
        "short": "Rent"
      },
      "investment-purchase": {
        "long": "Asset purchase",
        "short": "Asset purchase"
      },
      "investment-sale": {
        "long": "Asset sale",
        "short": "Asset sale"
      },
      "investment-payout": {
        "long": "Loan payout",
        "short": "Loan payout"
      },
      "investment-loanRepayment": {
        "long": "Loan repayment",
        "short": "Loan repayment"
      },
      "investment-loanInterest": {
        "long": "Loan repayment (interest)",
        "short": "Loan interest"
      },
      "investment-loanPrincipal": {
        "long": "Loan repayment (principal)",
        "short": "Loan principal"
      },
      "investment-pension": {
        "long": "Pension payout",
        "short": "Pension"
      },
      "investment-contribution": {
        "long": "Pension contribution",
        "short": "Contribution"
      }
    },
    "markThisTransaction": "Mark this transaction as",
    "noTransactions": "No transactions found on accounts connected to this one.",
    "noTransactionsWithin": "No similar sized transactions found within 7 days of this transaction's date on accounts connected to this one.",
    "noAccounts": "No connected accounts found.",
    "noAssets": "No assets found on connected accounts.",
    "addTag": "Add tag",
    "whichItem": "Which item does it apply to?"
  },
  "pension": {
    "import": {
      "title": "Which product to use?",
      "prompt": "You seem to be importing data from rvuebersicht.de. There are more than 1 products in this file. Please select the right entry for this account.",
      "ignore": "Ignore",
      "cancel": "Cancel",
      "baseCurrencyDialog": {
        "title": "Currency conversion",
        "prompt": "The currency of the imported data is different from the base currency of this account. How should we convert this currency? As it is difficult to predict the future exchange rate, we suggest to use today's.",
        "fxRate": "Exchange rate to use",
        "todayFxIs": "Today's exchange rate is",
        "apply": "Apply"
      }
    }
  },
  "contextMenu": {
    "addEmptyRowAbove": "Add empty row(s) above",
    "addEmptyRowBelow": "Add empty row(s) below",
    "addEmptyColumnAbove": "Add empty column(s) right",
    "addEmptyColumnBelow": "Add empty column(s) left",
    "duplicateRow": "Duplicate row",
    "duplicateColumn": "Duplicate column",
    "deleteRow": "Delete row",
    "deleteColumn": "Delete column",
    "cut": "Cut",
    "copy": "Copy",
    "paste": "Paste",
    "download": "Export everything to file",
    "downloadSelected": "Export selection to file"
  },
  "splitMenu": {
    "split": "Split",
    "splitHeader": "Split this transaction into two or more transactions",
    "splitInfo": "Remember to split transaction fees and purchase / sale transaction in the connected deposit account.",
    "splitExistingDetected": "This transaction has been split already, you can edit the existing splits above.",
    "copyAsSimulated": "Copy as simulated",
    "copyAsSimulatedInfo": "Create a simulated transaction based on this one. You can adjust all parameters in the next screen.",
    "showInProject": "Link to project",
    "showInProjectInfo": "You can show this actual transacton in a Project.",
    "aiLabelLoanRepayment": "Auto-detect interest and principal",
    "aiLabelLoanRepaymentInfo": "Use AI to identify principal and interest for this transaction (or all selected transactions) and apply the loan repayment label automatically.",
    "aiLabelLoanRepaymentRunning": "Processing selected transactions...",
    "aiLabelLoanRepaymentRunningTakesUpTo30s": "This can take up to 30 seconds.",
    "run": "Run",
    "separateInterestFromPrincipal": "Separate interest from principal",
    "splitAndLabelLoanInfo": "Break down this loan payment into principal and interest.",
    "splitAndLabelLoanInfo2": "We store the bank transaction as one loan repayment and use the split between principal and interest for loan history and KPI calculations.",
    "transactionDescriptionLabel": "Current transaction description",
    "transactionDescriptionEmpty": "No description",
    "calculateExpectedSplitInfo": "If there is no information about the interest and principal parts in transaction description, we can calculate them based on the loan parameters.",
    "calculateExpectedSplit": "Calculate expected split",
    "delete": "Delete",
    "pressSaveToDelete": "Press >Save< to delete this transaction.",
    "pick": "Pick a project",
    "error": "Please verify your entry.",
    "amountToAllocate": "Amount left to allocate",
    "allocatedTooMuch": "Allocated too much by",
    "amountToAllocateInterest": "Interest left to allocate",
    "allocatedTooMuchInterest": "Allocated too much interest by",
    "selectLoanAccount": "Select loan account"
  },
  "settings": {
    "symbol": "Symbol",
    "dividend": "Dividend (% per year)",
    "growthRate": "Growth rate (% per year)",
    "add": "Add",
    "simulatedAccountGrowth": {
      "heading": "Simulated account growth",
      "description": "This value will be used to simulate future growth of all your stocks in this account account. See this blog entry for more information.",
      "fieldLabel": "Growth rate",
      "dividendPayments": "You can also simulate future dividend payments - across all stocks accounts. Enter initial dividend per share per year, it will be increased annually by the above growth rate.",
      "dividendTooltip": "Dividend will be calculated as % of current value of the asset."
    },
    "spread": {
      "description": "We calculate up-to-date value of your precious metal assets based on the realistic price you will get for your asset when selling it.",
      "description2": "This price is lower than the market price due to the margin of the buyer (called 'spread'). We recommend a conservative spread of 10% of the market price, but you can change it here. Spread will be deducted from the current market value of your metal assets.",
      "label": "Spread (%)",
      "error": "Please provide a spread percentage"
    },
    "autoImportPretransformation": {
      "heading": "Remember file import settings",
      "body": "Next time you import a file for this account we can automatically apply the transformations you made to import files before.",
      "label": "Remember import settings"
    },
    "realEstateValuations": {
      "heading": "Select accounts for automatic valuation updates",
      "label": "We can automatically update valuations for some of your real estate accounts. Select which ones should that be."
    }
  },
  "loanIndicators": {
    "principalRemaining": "Remaining principal",
    "interestRemaining": "Remaining interest",
    "history": "History",
    "loanRepaid": "Capital repaid",
    "loanRepaidTooltip": "What percentage of capital has been repaid to date.",
    "interest": "Interest",
    "interestPaid": "paid to date",
    "interestTooltip": "Total amount of interest paid to date and what percentage of principal paid so far this is.",
    "interestPaidToPrincipalPaid": "vs principal paid",
    "balance": "Balance",
    "balanceTooltip": "Remaining amount to be paid (principal + interest), if the loan is paid off according to the schedule."
  },
  "pensionIndicators": {
    "presentValueChanges": "Changes to expected payouts",
    "roi": "Return on investment",
    "sumContributions": "Contributions",
    "sumContributionsTooltip": "Total amount of contributions paid to date.",
    "presentValue": "Product value",
    "presentValueTooltip": "Value of your pension product in today's money."
  },
  "unlistedShares": {
    "wizard": {
      "transactions": {
        "header": "What kind of transaction shall we add?",
        "moreShares": "Buy more shares",
        "moreCapital": "Increase equity capital (without emitting new shares)",
        "sharesSale": "Sell shares",
        "capitalDisbursement": "Receive equity capital as payout (capital disbursement)",
        "error": "Please pick one option",
        "formHeader": "Transaction details",
        "submit": "Save",
        "deleteThisTransaction": "Delete",
        "noConnectedDeposit": "Connect a deposit account first (use the button above, just below company name).",
        "clickToOpenDeposit": "In order to pay equity capital in or out without emitting or buying back shares, go to the connected deposit account and label your transaction as 'capital increase' or 'capital disbursement':",
        "quantity": {
          "label": "Amount of shares",
          "tooltip": "How many shares did you buy or sell?",
          "error": "Please provide a number of shares"
        },
        "upac": {
          "label": "Price per share",
          "tooltip": "Price per share in the account currency",
          "error": "Please provide a price per share"
        },
        "capitalAmount": {
          "label": "Capital increase amount",
          "tooltip": "By how much is the equity capital increased?",
          "error": "Please provide a capital increase amount"
        },
        "capitalDisbursementAmount": {
          "label": "Capital disbursement amount",
          "tooltip": "How much equity capital is paid out?",
          "error": "Please provide a capital disbursement amount"
        },
        "dateUserInput": {
          "label": "Transaction date",
          "tooltip": "When did the transaction take place?",
          "error": "Please provide a transaction date"
        }
      },
      "valuation": {
        "title": "Company valuation wizard",
        "description": "Start by selecting your company's lifecycle stage below or enter the valuation manually and click save.",
        "score": {
          "-2": {
            "label": "Much less",
            "tooltip": "Your company is in a significantly worse position than the market / its peers"
          },
          "-1": {
            "label": "Less",
            "tooltip": "Your company is in a worse position than the market / its peers"
          },
          "0": {
            "label": "Neutral",
            "tooltip": "Your company is in a similar position to the market / its peers"
          },
          "1": {
            "label": "More",
            "tooltip": "Your company is in a better position than the market / its peers"
          },
          "2": {
            "label": "Much more",
            "tooltip": "Your company is in a significantly better position than the market / its peers"
          }
        },
        "stage": {
          "label": "Stage",
          "tooltip": "The valuation methods that we can apply depend on the stage of your company. Select the stage that best describes your company at present.",
          "idea": {
            "label": "Idea",
            "tooltip": "The company is in the idea stage. It has not yet been founded."
          },
          "prototype": {
            "label": "Prototype",
            "tooltip": "The company has a prototype or the work is very advanced. Market launch has not happened yet."
          },
          "mvp": {
            "label": "MVP",
            "tooltip": "The company has a minimum viable product and is testing it on the market."
          },
          "expansion": {
            "label": "Expansion",
            "tooltip": "The company is growing rapidly and has a stable customer base."
          },
          "market": {
            "label": "Market",
            "tooltip": "The company is well established and has a strong customer base."
          }
        },
        "valuationMethod": {
          "label": "Available valuation methods",
          "tooltip": "Select the methods that you would like to use to value your company. You can select multiple methods."
        },
        "info": "Compare your company to similar companies in the market. The valuation methods will be applied based on the information you provide.",
        "insufficientData": "More data needed",
        "insufficientDataTooltip": "We need the following fields to calculate the valuation: {{fields}}.",
        "required": "Please provide both date and valuation.",
        "ideaStrength": {
          "label": "Idea strength",
          "tooltip": "The strength of the idea or business concept behind the company"
        },
        "prototypeProgress": {
          "label": "Prototype progress",
          "tooltip": "The progress made in developing the prototype of the product ('much less' if no prototype exists, 'much more' if a fully tested prototype exists)"
        },
        "teamCapability": {
          "label": "Team capability",
          "tooltip": "The capability and experience of the team members"
        },
        "marketingRelationships": {
          "label": "Marketing relationships",
          "tooltip": "The strength and extent of marketing / supply chain relationships"
        },
        "marketTraction": {
          "label": "Market traction",
          "tooltip": "Success in bringing product to the market / sales growth"
        },
        "competitiveAdvantage": {
          "label": "Competitive advantage",
          "tooltip": "Is there any kind of advantage this company has against its competitors?"
        },
        "similarStartupValuationsArray": {
          "label": "Similar company valuations",
          "tooltip": "Approximate valuations for similar companies"
        },
        "technologyRisk": {
          "label": "Technology confidence",
          "tooltip": "Comparing to similar companies, is the technology used by this company more or less risky?"
        },
        "ipStrength": {
          "label": "IP strength",
          "tooltip": "Does the company hold all key patents / IP necessary for launch and further growth?"
        },
        "totalAdressableMarketSize": {
          "label": "Total addressable market size",
          "tooltip": "The total size of the market that the company can address"
        },
        "marketGrowthRate": {
          "label": "Market growth rate",
          "tooltip": "The growth rate of the market in which the company operates"
        },
        "marketEntryBarriers": {
          "label": "Market entry barriers",
          "tooltip": "How difficult (because of capital, tools, IP etc.) is it to start a company in this market?"
        },
        "needForMoreInvestment": {
          "label": "Need for more investment",
          "tooltip": "How much more investment is needed to bring the company to the next level?"
        },
        "legalRisk": {
          "label": "Legal stability",
          "tooltip": "The more legal (legislation, patents etc.) risks the company may face, the smaller the stability."
        },
        "internationalRisk": {
          "label": "International stability",
          "tooltip": "The risks associated with expanding operations internationally"
        },
        "marketRisk": {
          "label": "Market stability",
          "tooltip": "Is the market in which the company operates stable ('more') or volatile ('less')?"
        },
        "financialPerformance": {
          "label": "Financial performance",
          "tooltip": "The financial performance of the company (profitability)"
        },
        "assetsArray": {
          "label": "Assets",
          "tooltip": "An array of the company's assets"
        },
        "intangiblesArray": {
          "label": "Intangibles",
          "tooltip": "An array of the company's intangible assets"
        },
        "liabilitiesArray": {
          "label": "Liabilities",
          "tooltip": "An array of the company's liabilities"
        },
        "targetRaisedCapital": {
          "label": "Capital to raise",
          "tooltip": "What capital is your company currently looking to raise?"
        },
        "cashFlowArray": {
          "label": "Cash flows",
          "namePlaceholder": "Year",
          "tooltip": "What are the expected cash flows of the company?"
        },
        "discountRate": {
          "label": "Discount rate (in %)",
          "tooltip": "The discount rate used in the DCF method (cost of capital for your company, i.e. approx. what interest is the company paying on loans)"
        },
        "longTermGrowthRate": {
          "label": "Stable growth rate (in %)",
          "tooltip": "Long-term, sustainable growth rate once cash flows are stable (should be conservative /2-4%/ and lower than the discount rate). Will be used to calculate the terminal value.",
          "error": "Stable growth rate must be lower than discount rate for this calculation."
        },
        "finalQuote": {
          "label": "Final valuation",
          "tooltip": "What valuation would you like to save, given the information provided?",
          "error": "Please provide a final valuation",
          "description": "Determine the final valuation of the company based on the information provided.",
          "save": "Save",
          "deleteThisQuote": "Delete this valuation",
          "resetThisQuote": "Reset this valuation"
        },
        "percentOwned": {
          "label": "Percentage owned",
          "tooltip": "What percentage of the company do you own?",
          "error": "Please provide a percentage owned"
        },
        "methods": {
          "berkus": {
            "label": "Berkus",
            "tooltip": "A method evaluating startups based on idea, prototype, team, market traction, and competitive advantage."
          },
          "scorecard": {
            "label": "Scorecard",
            "tooltip": "A method assessing startups using a scoring system to compare various aspects such as team, product, and market."
          },
          "riskFactor": {
            "label": "Risk Factor",
            "tooltip": "A method evaluating the risks involved in a startup, including technology, market, and team risks."
          },
          "valuationByStage": {
            "label": "Valuation by Stage",
            "tooltip": "A method determining the valuation of a startup based on its current stage of development."
          },
          "replacementCost": {
            "label": "Replacement Cost",
            "tooltip": "A method calculating the cost to replace the company's assets and operations."
          },
          "bookValue": {
            "label": "Book Value",
            "tooltip": "A method assessing the net asset value of a company by subtracting liabilities from assets."
          },
          "fiveTimesYourRise": {
            "label": "Five Times Your Rise",
            "tooltip": "A method multiplying the target capital raise by five to estimate the company's value."
          },
          "dcf": {
            "label": "DCF",
            "tooltip": "A Discounted Cash Flow method evaluating a company based on its projected future cash flows."
          }
        }
      }
    }
  },
  "cryptoAssetMappingDialog": {
    "header": "Automatic price updates",
    "prompt": "Cryptocurrencies are decentralised. To make sure we are getting the right price for your assets, we need to confirm we found the right one. Please check the following mappings and click >Save<. You may leave some of them empty if you don't want to update the price for this asset.",
    "asset": "Crypto symbol",
    "status": "Prices found",
    "headerAssetDetails": "Find prices for:",
    "promptAssetDetails": "These are cryptocurrencies for which we can update prices automatically. Select the one you own or search for a new keyword and click >OK<. You may leave all items unselected if they don't match your assets.",
    "search": "Search prices for:",
    "symbol": "Symbol",
    "name": "Name",
    "marketCap": "Market size",
    "liquidity": "Liquidity",
    "price": "Current price",
    "page": "Page",
    "pageOf": "of",
    "next": "Next",
    "previous": "Previous",
    "noResults": "No prices found"
  },
  "filterDialog": {
    "filter": "Filter",
    "prompt": "Select only cells which fulfill the following conditions:",
    "is": "is",
    "isNot": "is not",
    "contains": "contains",
    "doesNotContain": "does not contain",
    "startsWith": "starts with",
    "doesNotStartWith": "does not start with",
    "endsWith": "ends with",
    "doesNotEndWith": "does not end with",
    "greaterThan": "greater than",
    "greaterThanOrEqual": "greater than or equal to",
    "lessThan": "less than",
    "lessThanOrEqual": "less than or equal to",
    "equalTo": "equal to",
    "blank": "blank",
    "phrase": "phrase",
    "addMore": "Add more",
    "cancel": "Cancel",
    "rulesErrorLength": "Value may not exceed 200 characters.",
    "rulesErrorNumber": "Value must be a number."
  },
  "tableFilters": {
    "results": "{{shown}} of {{total}} rows",
    "clearAll": "Clear filters"
  },
  "tableFiltersDialog": {
    "title": "Filter list",
    "description": "Refine the visible rows without changing your data.",
    "searchLabel": "Search phrase",
    "searchPlaceholder": "Description, counterparty, IBAN...",
    "amountLabel": "Amount",
    "amountAny": "Any amount",
    "amountInflow": "Inflow only",
    "amountOutflow": "Outflow only",
    "amountZero": "Zero amount",
    "dateLabel": "Date",
    "dateAll": "All dates",
    "date30d": "Last 30 days",
    "date90d": "Last 90 days",
    "date365d": "Last 12 months",
    "reset": "Reset",
    "cancel": "Cancel",
    "apply": "Apply filters"
  },
  "gettingStarted": {
    "heading": "Getting started",
    "subheading": "Fill your new account with data",
    "intro": "It is easy to get started and it is up to you to decide how to do that.\nRemember: everything you do can be updated later.",
    "features": [
      {
        "name": "Enter the current saldo",
        "description": "Click >Edit<, enter the current account saldo and save. You can add more details later."
      },
      {
        "name": "Import transactions from file",
        "description": "Download a transaction extract file from your bank's online banking. Once you have it, press the >Import< button and follow our step-by-step instructions."
      },
      {
        "name": "Get transactions automatically",
        "description": "If there is a technical link, you can get your transactions automatically. Just press the >Sync< button and we will do the rest."
      }
    ],
    "cashflow": {
      "heading": "Why are there no data here?",
      "subheading": "Tag the related payouts and costs in the connected deposit account",
      "intro": "Add the transactions in the connected deposit account and tag them for this account so they show up here.",
      "navigateIntro": "Open the linked deposit account to add and tag the transactions for this asset:"
    },
    "values": {
      "heading": "Custom values",
      "subheading": "Maintain your own price history",
      "intro": "Add your own prices when market data is missing or you want to override it.",
      "features": [
        {
          "name": "Edit prices in Grid",
          "description": "Press Edit to switch into the Grid and enter your custom prices per asset, then save."
        },
        {
          "name": "Import valuations",
          "description": "Use Import to upload price data instead of typing everything manually."
        }
      ]
    }
  }
}
